import React from "react";

const Story = () => {
  return (
    <div className="space-y-8">
      <div className="text-center mb-12">
        <h2 className="font-['Cabin_Sketch'] text-5xl md:text-6xl text-[#D32F2F] font-bold mb-4 text-shadow-lg">
          What you'll do
        </h2>
        <p className="text-[#2E7D32] text-xl md:text-2xl font-semibold">
          Each phase comes a new category of challenges. Even if something seems outside your skill-level, try it out. All challenges have tests built-in to give you feedback.
        </p>
      </div>

      <div className="space-y-8">
        {/* Phase 1 */}
        <div className="bg-gradient-to-br from-[#FFF9E6] to-[#FFF9C4] p-8 md:p-10 rounded-3xl border-4 border-dashed border-[#2E7D32] shadow-xl">
          <h3 className="font-['Cabin_Sketch'] text-3xl md:text-4xl text-[#1B5E20] font-bold mb-6 flex items-center gap-4">
            Phase 1 - Flows, Apex, and Validation Rules
          </h3>
          <p className="text-[#3E2723] text-lg md:text-xl leading-relaxed font-semibold">
            Before baby arrives, Grandma Kelly is setting up a CRM to help keep everyone organized. She needs your help automating Salesforce. You'll build record-triggered automation in your connected org for Grandma Kelly.
          </p>
        </div>

        <div className="bg-gradient-to-br from-[#FFF9E6] to-[#FFF9C4] p-8 md:p-10 rounded-3xl border-4 border-dashed border-[#2E7D32] shadow-xl">
          <h3 className="font-['Cabin_Sketch'] text-3xl md:text-4xl text-[#1B5E20] font-bold mb-6 flex items-center gap-4">
            Phase 2 - Apex Fundamentals, Algorithms, and Data Structures
          </h3>
          <p className="text-[#3E2723] text-lg md:text-xl leading-relaxed font-semibold">
            Now that the CRM is setup, the team is tackling last minute tasks. You'll use CampApex.org's built-in editor to solve Apex challenges to help out the team.
          </p>
        </div>

        {/* Phase 2 */}
        <div className="bg-gradient-to-br from-[#FFF9E6] to-[#FFF9C4] p-8 md:p-10 rounded-3xl border-4 border-dashed border-[#2E7D32] shadow-xl">
          <h3 className="font-['Cabin_Sketch'] text-3xl md:text-4xl text-[#1B5E20] font-bold mb-6 flex items-center gap-4">
            Phase 3 - Apex Integrations - GET and POST data
          </h3>
          <p className="text-[#3E2723] text-lg md:text-xl leading-relaxed font-semibold">
            Once the baby arrives, the team will need real data integrations to make sure they're keeping track of the baby's health, saftey, and to share updates with others. Help them out by building Apex integrations.
          </p>
        </div>

        {/* Tone Section */}
        <div className="bg-gradient-to-br from-[#D32F2F] to-[#C1272D] text-white p-8 md:p-10 rounded-3xl text-center border-4 border-[#FFD700] shadow-2xl">
          <h4 className="font-['Cabin_Sketch'] text-3xl md:text-4xl font-bold mb-6">
            Meet The Team
          </h4>
          <div className="grid md:grid-cols-2 gap-6 text-left mb-8">
            <div className="bg-white/10 p-4 rounded-xl backdrop-blur-sm">
              <h5 className="font-bold text-xl mb-2">🍪 Grandma Kelly</h5>
              <p className="text-sm">
                Grandma takes charge - getting the CRM setup to keeps everyone organized, on-track and fed
              </p>
            </div>
            <div className="bg-white/10 p-4 rounded-xl backdrop-blur-sm">
              <h5 className="font-bold text-xl mb-2">💑 Mama & Papa</h5>
              <p className="text-sm">
                The expecting parents who need help making sure baby's first Christmas is perfect
              </p>
            </div>
             <div className="bg-white/10 p-4 rounded-xl backdrop-blur-sm">
              <h5 className="font-bold text-xl mb-2">🩺 Dr. Grace Evergreen</h5>
              <p className="text-sm">
                The pediatrician who ensures everything is safe, healthy, and
                ready for the baby
              </p>
            </div>
             <div className="bg-white/10 p-4 rounded-xl backdrop-blur-sm">
              <h5 className="font-bold text-xl mb-2">🧵 Monica McPatchwork</h5>
              <p className="text-sm">
                The quilter who stitches blankets & stockings to keep the family warm
              </p>
            </div>
            <div className="bg-white/10 p-4 rounded-xl backdrop-blur-sm">
              <h5 className="font-bold text-xl mb-2">👷‍♀️ Stella Pinewood</h5>
              <p className="text-sm">
                The carpenter who builds the nursery, crib, and dresser
              </p>
            </div>
            <div className="bg-white/10 p-4 rounded-xl backdrop-blur-sm">
              <h5 className="font-bold text-xl mb-2">💡 Finn Brightwick</h5>
              <p className="text-sm">
                The electrician who sets up the Christmas lights and baby monitors
              </p>
            </div>
            <div className="bg-white/10 p-4 rounded-xl backdrop-blur-sm">
              <h5 className="font-bold text-xl mb-2">🎨 Poppy Wintergold</h5>
              <p className="text-sm">
                The decorator with an eye for color and a passion for creating
                cozy spaces
              </p>
            </div>
            <div className="bg-white/10 p-4 rounded-xl backdrop-blur-sm">
              <h5 className="font-bold text-xl mb-2">
                🎵 Shakira Maestro
              </h5>
              <p className="text-sm">
                The choir director who orchestrates every carol and lullaby
              </p>
            </div>
            <div className="bg-white/10 p-4 rounded-xl backdrop-blur-sm">
              <h5 className="font-bold text-xl mb-2">🌿 Ivy Evergreen</h5>
              <p className="text-sm">
                The gardener who brings wreaths, garlands, and natural beauty
                indoors
              </p>
            </div>
            <div className="bg-white/10 p-4 rounded-xl backdrop-blur-sm">
              <h5 className="font-bold text-xl mb-2">🧸 Tinker Bellwright</h5>
              <p className="text-sm">
                The toymaker who crafts baby's first teddy-bear and toys
              </p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .text-shadow-lg {
          text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.1);
        }

        .drop-shadow-glow {
          filter: drop-shadow(0 0 10px rgba(255, 215, 0, 0.6));
        }
      `}</style>
    </div>
  );
};

export default Story;
